import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { Body2, Title4 } from '../../tokens';

import { cn } from '../../../lib/utils';

const alertVariants = cva(
  'relative w-full flex flex-row items-center gap-x-md',
  {
    variants: {
      variant: {
        warning: 'bg-warning-weak',
        negative: 'bg-negative-weak',
        positive: 'bg-positive-weak',
      },
      placement: {
        'butter-bar': 'rounded-2xl p-md',
        embedded: 'rounded-card-inside-card-shape p-sm',
      },
    },
    defaultVariants: {
      variant: 'warning',
      placement: 'butter-bar',
    },
  },
);

const Alert = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement> & VariantProps<typeof alertVariants>
>(({ children, className, variant, placement, ...props }, ref) => (
  <div
    ref={ref}
    role="alert"
    className={cn(alertVariants({ variant, placement }), className)}
    {...props}
  >
    {children}
  </div>
));
Alert.displayName = 'Alert';

const AlertTitle = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLHeadingElement>
>(({ children, ...props }, ref) => (
  <Title4 ref={ref} {...props}>
    {children}
  </Title4>
));
AlertTitle.displayName = 'AlertTitle';

const AlertDescription = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLParagraphElement>
>(({ children, ...props }, ref) => (
  <Body2 ref={ref} {...props}>
    {children}
  </Body2>
));
AlertDescription.displayName = 'AlertDescription';

export { Alert, AlertTitle, AlertDescription };
